<template>
  <section style="flex: 1">
    <div class="d-flex funnel-filter">
      <div class="form-group">
        <DropdownCheckbox
          v-model="sourceFilterDataModel"
          :options="getSourceList"
          @input="handleSources"
          name="funnel-chart-two"
          label="description"
          placeholder="Source"
        />
      </div>

      <div class="form-group">
        <TimeRange
          name="funnel-two-time-range"
          @input="handleTimeRangeFilter"
          v-model="timeRangeDataModel"
        />
      </div>
    </div>
    <div style="display:flex; background:#000"></div>

    <VueFunnelGraph
      v-if="values.length"
      :height="thefunnelHeight"
      :width="theFunnelWidth"
      :labels="labels"
      :values="values"
      :colors="colors"
      :sub-labels="subLabels"
      :direction="direction"
      :display-percentage="false"
      subLabelValue="raw"
      :animated="true"
      :displayPercent="true"
    />
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import { VueFunnelGraph } from '../../../Admin/Dashboard/vue-funnel-graph';
import { VueFunnelGraph } from 'vue-funnel-graph-js';
import DropdownCheckbox from '@/components/common/DropdownCheckbox/DropdownCheckbox';
import TimeRange from '@/components/common/TimeRange/TimeRange';

export default {
  components: {
    VueFunnelGraph,
    TimeRange,
    DropdownCheckbox,
  },
  data: () => ({
    sourceFilterDataModel: [],
    timeRangeDataModel: { value: 'all_time', option: 'All time' },
    labels: ['Not contacted', 'Contacted', 'Interviewing', 'Offered employment', 'Employed'],
    subLabels: [],
    values: [],
    colors: [
      ['#f02800', '#f02800'],
      ['#5bb75b', '#5bb75b'],
      ['#0088cc', '#0088cc'],
      ['#913d8b', '#913d8b'],
      ['#043852', '#043852'],
    ],
    width: 800,
    height: 288,
    thefunnelHeight: 200,
    theFunnelWidth: 800,
    direction: 'horizontal',
    gradientDirection: 'horizontal',
    isLoading: false,

    sourceOptions: [],
    selectedSources: [],
    timeRange: { value: 'all_time', option: 'All time' },
    defaultSource: [
      {
        description: 'Uploaded',
        id: '6be720a3-e171-4803-b671-c5f684da5a44',
        source_name: 'UL',
      },
    ],
    finalObject: {},
    funnelData: [],
    objectZero: {
      101: 0,
      102: 0,
      103: 0,
      104: 0,
      106: 0,
      107: 0,
    },
  }),
  methods: {
    ...mapActions(['retrieveSourcesList', 'retrieveFunnelTwoData']),
    handleSources() {
      this.fetchFunnelTwotData(this.sourceFilterDataModel, this.timeRangeDataModel.value);
    },
    handleTimeRangeFilter() {
      this.fetchFunnelTwotData(this.sourceFilterDataModel, this.timeRangeDataModel.value);
    },
    /*  formatResponse(data) {
      this.finalObject = {};
      this.funnelData = [];

      for (const key in data) {
        let title = Object.keys(data[key])[0];
        let currentData = Object.values(data[key])[0];

        if (currentData.length === 0) {
          currentData = {};
        }

        this.finalObject = {
          title,
          data: {
            ...this.objectZero,
            ...currentData,
          },
        };

        this.funnelData.push(this.finalObject);
      }
    }, */
    formatResponse(data) {
      this.finalObject = {};
      this.funnelData = [];

      for (const key in data) {
        let title = Object.keys(data[key])[0];
        let currentData = Object.values(data[key])[0];

        if (currentData.length === 0) {
          currentData = {};
        }

        this.finalObject = {
          title,
          data: {
            // Assuming you're dynamically assigning values, adjust as needed
            102: currentData[102] || 0, // Not contacted
            103: currentData[103] || 0, // Contacted
            104: currentData[104] || 0, // Interviewing
            106: currentData[106] || 0, // Offered employment
            107: currentData[107] || 0, // Employed
          },
        };
        this.funnelData.push(this.finalObject);
      }
    },
    fetchFunnelTwotData(jobs, timeRange) {
      this.isLoading = true;

      this.retrieveFunnelTwoData({
        source_ids: jobs.map(s => s.id),
        date: [timeRange],
      })
        .then(response => {
          this.formatResponse(response.data);

          const tempSubLabels = [];
          const rows = this.labels.length; // Adjusted to new label count
          const columns = Math.min(rows, this.funnelData.length);
          const tempData = Array.from({ length: rows }, () => new Array(columns).fill(0));

          for (let i = 0; i < rows; i++) {
            for (let j = 0; j < columns; j++) {
              const { title, data } = this.funnelData[j];
              const templist = Object.values(data);

              if (j === i) {
                tempSubLabels[i] = title;
              }

              tempData[i][j] = templist[i];
            }
          }

          this.subLabels = tempSubLabels;
          this.values = tempData;

          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
  computed: {
    ...mapGetters(['getFunnelTwoData', 'getSourceList']),
  },
  watch: {
    sourceFilterDataModel(newSelectedSource) {
      this.localStoragePlugin.set('funnelTwoSourceSelect', newSelectedSource);
    },
    timeRangeDataModel(newSelectedTimeRange) {
      this.localStoragePlugin.set('funnelTwoTimeRangeSelect', newSelectedTimeRange);
    },
  },
  mounted() {
    this.theFunnelWidth = document.getElementById('cardu2').offsetWidth;

    if (this.localStoragePlugin.has('funnelTwoSourceSelect')) {
      this.sourceFilterDataModel = this.localStoragePlugin.get('funnelTwoSourceSelect');
    }

    if (this.localStoragePlugin.has('funnelTwoTimeRangeSelect')) {
      this.timeRangeDataModel = this.localStoragePlugin.get('funnelTwoTimeRangeSelect');
    }

    this.fetchFunnelTwotData(this.sourceFilterDataModel, this.timeRangeDataModel.value);
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.funnel-filter {
  display: flex;
  justify-content: space-between;
  padding: 12px;
  .form-control {
    width: 50%;
    flex-shrink: 0;
  }
  .form-group {
    width: 49.8%;
    flex-shrink: 0;
  }
  .dropdown-toggle {
    display: block;
    width: 100%;
  }
}
</style>
